module.exports = __webpack_public_path__ + "img/spain-ovarian-cancer-female.fe7d3ca4.png";